import { uiText } from '@/i18n/interface';

import { useToast } from "@/hooks/use-toast";
import { supabase } from '@/integrations/supabase/client';
import { PaymentCategory } from '@/types/payment';

export const usePaymentCategoryManager = () => {
  const { toast } = useToast();

  const updateCategory = async (
    categoryId: string,
    field: string,
    value: any,
    setCategories: React.Dispatch<React.SetStateAction<PaymentCategory[]>>
  ) => {
    try {
      let updateData: any = {};

      // Handle different field types
      switch (field) {
        case 'oneYear':
          updateData.one_year_amount = Math.round(value * 100); // Convert to cents
          break;
        case 'sixMonths':
          updateData.six_months_amount = Math.round(value * 100); // Convert to cents
          break;
        case 'threeMonths':
          updateData.three_months_amount = Math.round(value * 100); // Convert to cents
          break;
        case 'monthly':
          updateData.monthly_amount = Math.round(value * 100); // Convert to cents
          break;
        case 'currency':
          updateData.currency = value;
          break;
        case 'paymentMethods':
          updateData.payment_methods = value;
          break;
        case 'isActive':
          updateData.is_active = value;
          break;
        case 'stripeIntegrationEnabled':
          updateData.stripe_integration_enabled = value;
          break;
        case 'stripePriceIds':
          updateData.stripe_price_ids = value;
          break;
        case 'paymentLinks':
          updateData.payment_links = value;
          break;
        case 'autoGenerateLinks':
          updateData.auto_generate_links = value;
          break;
        default:
          console.warn(`Unknown field: ${field}`);
          return;
      }

      const { error } = await supabase
        .from('payment_categories')
        .update(updateData)
        .eq('id', categoryId);

      if (error) {
        console.error('Error updating category:', error);
        toast({
          title: uiText("Error"),
          description: uiText("Failed to update category"),
          variant: "destructive"
        });
        return;
      }

      // Update local state
      setCategories(prev => prev.map(cat =>
        cat.id === categoryId
          ? {
              ...cat,
              ...(field === 'oneYear' || field === 'sixMonths' || field === 'threeMonths' || field === 'monthly'
                ? { amounts: { ...cat.amounts, [field]: value } }
                : { [field]: value }
              )
            }
          : cat
      ));

      toast({
        title: uiText("Category Updated"),
        description: uiText("Category {{value0}} updated successfully", { value0: field === 'paymentMethods' ? uiText("payment methods") : field })
      });
    } catch (error) {
      console.error('Error updating category:', error);
      toast({
        title: uiText("Error"),
        description: uiText("Failed to update category"),
        variant: "destructive"
      });
    }
  };

  return {
    updateCategory
  };
};
